export const checkComparedCoinsValue = (
  isGeneratedFromNow?: boolean,
  isLocationChosen?: boolean,
  canBeCompare?: boolean,
): number => ((isGeneratedFromNow
        && isLocationChosen
        && canBeCompare)
  ? 2
  : 1)
